import React, { useState, useEffect } from "react";
import { ENV } from "../../config/config";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import { useGetGalleryQuery, useCreateGalleryMutation, useDeleteGalleryMutation } from "../../redux/api";
import { useGetRoleQuery } from "../../redux/api";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import localeInfo from "rc-pagination/lib/locale/en_US";
import {
  Button,
  Card,
  Form,
  Table,
  Container,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import { FaPlus, FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useEffect as useEffectReact, useState as useStateReact } from "react";
import GalleryModal from "./galleryModal";
const { objectToQueryString, decimalNumberValidator } = ENV;
var CryptoJS = require("crypto-js");

const Gallery = () => {
  const [gallery, setGallery] = useState([]);
  const [image, setImage] = useState();
  const [galleryErrors, setGalleryErrors] = useState();
  const [pagination, setPagination] = useState(null);
  const [resetButton, setResetButton] = useState(false);
  const [permissions, setPermissions] = useState({});
  const [filters, setFilters] = useState({
    name: "",
  });
  const [openModal, setOpenModal] = useState(false);
  const [qs, setQs] = useState("");
  const { data: galleryData, isLoading: isGalleryLoading, isFetching: isGalleryFetching, refetch } = useGetGalleryQuery(qs);
  const [createGallery, { isLoading: isCreatingGallery }] = useCreateGalleryMutation();
  const [deleteGallery, { isLoading: isDeletingGallery }] = useDeleteGalleryMutation();

  

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const roleEncrypted = localStorage.getItem("role");
  const roleDecrypted = roleEncrypted
    ? CryptoJS.AES.decrypt(roleEncrypted, ENV.secretKey).toString(
        CryptoJS.enc.Utf8
      )
    : "";
  const { data: roleData, isLoading: isRoleLoading, isFetching: isRoleFetching } = useGetRoleQuery(roleDecrypted, { skip: !roleEncrypted });

  const isGlobalLoading = isGalleryLoading || isGalleryFetching || isRoleLoading || isRoleFetching || isCreatingGallery || isDeletingGallery;

  useEffect(() => {
    if (roleData && roleData.role?.permissions) {
      if (typeof roleData.role.permissions === 'string') {
        setPermissions(JSON.parse(roleData.role.permissions));
      } else {
        setPermissions(roleData.role.permissions);
      }
    }
  }, [roleData]);

  useEffect(() => {
    if (galleryData) {
      setGallery(galleryData.gallery);
      setPagination(galleryData.pagination);
    }
  }, [galleryData]);

  const onPageChange = async (page) => {
    const nextQs = objectToQueryString({ page, ...filters });
    setQs(nextQs);
  };

  const applyFilters = () => {
    if (filters && filters.name) {
      setResetButton(true);
      const nextQs = objectToQueryString({ page: 1, limit: 10, ...filters });
      setQs(nextQs);
    } else {
      toast.error("Search fields are empty.", {
        toastId: "FIELD_REQUIRED",
      });
    }
  };

  const deleteHandler = (imageId) => {
    Swal.fire({
      title: "Are you sure you want to delete?",
      html: "If you delete an item, it will be lost permanently.",
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then(async (result) => {
      if (result.value) {
        try {
          const response = await deleteGallery({ id: imageId }).unwrap();
          if (response.success) {
            toast.success(response.message);
            refetch();
          }
        } catch (error) {
          // Check if the image is in use (409 Conflict)
          if (error?.data?.inUse) {
            const { usageCount, usageSummary } = error.data;
            
            // Build usage details message
            let usageMessage = `<p style="text-align: left;">This image is currently used by:</p><ul style="text-align: left;">`;
            if (usageSummary?.content) {
              usageMessage += `<li><strong>${usageSummary.content}</strong> content item(s)</li>`;
            }
            if (usageSummary?.category) {
              usageMessage += `<li><strong>${usageSummary.category}</strong> category(ies)</li>`;
            }
            if (usageSummary?.event) {
              usageMessage += `<li><strong>${usageSummary.event}</strong> event(s)</li>`;
            }
            if (usageSummary?.slider) {
              usageMessage += `<li><strong>${usageSummary.slider}</strong> slider(s)</li>`;
            }
            usageMessage += `</ul><p><strong>Total: ${usageCount} reference(s)</strong></p>`;
            usageMessage += `<p style="color: #d33;">Deleting will remove this image from all these items.</p>`;
            
            // Show warning with force delete option
            Swal.fire({
              title: "Image In Use",
              html: usageMessage,
              icon: "warning",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonColor: "#d33",
              cancelButtonColor: "#6c757d",
              confirmButtonText: "Delete Anyway",
              cancelButtonText: "Cancel",
            }).then(async (forceResult) => {
              if (forceResult.value) {
                try {
                  const forceResponse = await deleteGallery({ id: imageId, force: true }).unwrap();
                  if (forceResponse.success) {
                    toast.success(forceResponse.message);
                    refetch();
                  }
                } catch (forceError) {
                  toast.error(forceError?.data?.message || "Failed to delete image");
                }
              }
            });
          } else {
            toast.error(error?.data?.message || "Failed to delete image");
          }
        }
      }
    });
  };

  const reset = () => {
    setResetButton(false);
    setFilters({ name: "" });
    setQs("");
  };

  const resetModalContent = () => {
    // setGallery();
    setImage();
    setGalleryErrors();
  };
  const modalCloseHandler = () => {
    setOpenModal(!openModal);
    resetModalContent();
  };

  const submit = () => {
    let isValid = true;

    isValid &= image && image !== "" ? true : false;

    if (!isValid) {
      setGalleryErrors("This field is required.");
    } else {
      var formData = new FormData();
      formData.append("image", image);
      createGallery(formData).then(() => {
        refetch();
        modalCloseHandler();
      });
    }
  };

  const copyToClipboard = async (url) => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Url copied successfully!");
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  if (isGlobalLoading) {
    return <FullPageLoader />;
  }

  return (
    <>
        <Container fluid>
          <Row className="pb-3">
            <Col sm={12}>
              <Card className="filter-card">
                <Card.Header>
                  <div className="d-flex align-items-center justify-content-between table-head">
                    <Card.Title as="h4">Filters</Card.Title>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col xl={4} sm={6}>
                      <Form.Group>
                        <label>Search with name...</label>
                        <Form.Control
                          value={filters.name}
                          type="text"
                          placeholder="Search with name..."
                          onChange={(e) =>
                            setFilters({ ...filters, name: e.target.value })
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col xl={4} md={6}>
                      <Form.Group>
                        <Form.Label className="d-block mb-2">&nbsp;</Form.Label>
                        <div className="d-flex  filter-btns-holder">
                          <Button
                            className="btn-filled mr-3"
                            onClick={applyFilters}
                          >
                            Search
                          </Button>
                          {resetButton && (
                            <Button
                              variant="warning"
                              className="outline-button"
                              onClick={reset}
                            >
                              Reset
                            </Button>
                          )}
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col md="12">
              <Card className="table-big-boy">
                <Card.Header>
                  <div className="d-flex align-items-center justify-content-between table-head">
                    <Card.Title as="h4">Gallery</Card.Title>
                    {permissions && permissions.addGallery && (
                      <Button
                        className="float-sm-right btn-filled d-flex align-items-center"
                        onClick={() => {
                          resetModalContent();
                          setOpenModal(true);
                        }}
                      >
                        <span className="add-icon mr-2">
                          <FaPlus />
                        </span>
                        Add Image
                      </Button>
                    )}
                  </div>
                </Card.Header>
                <Card.Body className="card-full-width">
                  <div className="card-responsive">
                    <Row>
                      {gallery && gallery.length ? (
                        gallery.map((image, index) => {
                          return (
                            <Col md="3">
                              <Card
                                key={index}
                                style={{ width: "18rem", border: "solid" }}
                              >
                                <Card.Img
                                  variant="top"
                                  src={
                                    ENV.assetsUrl + "gallery/" + image?.image
                                  }
                                />
                                <Card.Body>
                                  <Card.Title>{image.name}</Card.Title>
                                  {permissions && permissions.deleteGallery && (
                                    <Button
                                      type="button"
                                      className="btn-link btn-icon btn btn-danger"
                                      variant="danger"
                                      onClick={() => {
                                        deleteHandler(image.id);
                                      }}
                                    >
                                      <FaTrash /> Delete
                                    </Button>
                                  )}
                                </Card.Body>
                              </Card>
                            </Col>
                          );
                        })
                      ) : (
                        <div className="alert alert-info" role="alert">
                          No Image Found
                        </div>
                      )}
                    </Row>
                  </div>
                </Card.Body>
                <Card.Footer>
                  {pagination && (
                    <Pagination
                      className="m-3"
                      defaultCurrent={1}
                      pageSize // items per page
                      current={pagination.page} // current active page
                      total={pagination.pages} // total pages
                      onChange={onPageChange}
                      locale={localeInfo}
                    />
                  )}
                </Card.Footer>
              </Card>
            </Col>
          </Row>
          <GalleryModal
            modalCloseHandler={modalCloseHandler}
            openModal={openModal}
            setOpenModal={setOpenModal}
            image={image}
            setImage={setImage}
            submit={submit}
            galleryErrors={galleryErrors}
            setGalleryErrors={setGalleryErrors}
          />
        </Container>
    </>
  );
};

export default Gallery;
